import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../context/auth-context';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsUp } from '@fortawesome/free-solid-svg-icons';

const Like = ({postId, initialLikes, isLikedByUser}) => {
    const { user } = useContext(AuthContext)
    const auth = useContext(AuthContext)
    const [likes, setLikes] = useState(initialLikes);
    const [liked, setLiked] = useState(isLikedByUser);

    useEffect(() => {
      // console.log('Updated liked state:', liked);
      // console.log('Updated likes state: ', likes)
    }, [liked, likes])

    // useEffect(() => {
    //   setLikes(initialLikes);
    //   setLiked(isLikedByUser)
    // }, [postId, initialLikes,isLikedByUser])

     // Like
  const likeHandler = async () => {
    if (!user) {
      console.log('User not authenticated');
      return
    }
 
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/posts/${postId}/like`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + auth.token
        },
        body: JSON.stringify({userId: user.id})
      });

      if (!response.ok) {
        throw new Error('Failed to like post')
      }

      const responseData = await response.json()
   
      setLikes(responseData.likes);
      // console.log('this is like res:', responseData.likes)

      const userLiked = responseData.likes.some(like => like.id === user.id)
      setLiked(userLiked);
      
    } catch (err) {
      console.log(err.message);
    }   
  }
 
  const handelClick = () => {
     if (!user){
      alert("Please Log in!");
      return;
     }
     likeHandler();
  }
   

    return (
        <main >        
            <button onClick={handelClick} className='footer-like' >
             
            {' '}
            {likes.length}   
              
              {likes.map((like, i) => (
                <div key={i}>
           
                  {/* {like.name} */}
                  {/* <img 
                    src={`${process.env.REACT_APP_ASSET_URL}/${like.image}`} 
                    alt={like.name} 
                    title={like.name}
                    style={{width: '20px', height:'20px', borderRadius: '50px'}}
                  /> */}
                </div>
              ))}
              &nbsp;&nbsp;<FontAwesomeIcon icon={faThumbsUp} style={{fontSize: '1rem'}}/>
            </button>
        </main>
    )
}
export default Like;